import axios from "axios";
import { oss } from "@/aips/canvas/aiCanvasApi.js";

export default {
  data() {
    return {
      aliyunOssToken: {},
    };
  },
  methods: {
    // 生成简单的 UUID，用于构造 OSS 文件名
    getUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    // 获取反馈截图上传的 OSS 授权
    getOssToken() {
      // 返回 Promise，方便上传时刷新 token 后重试
      return oss().then((res) => {
        if (res && res.status === 200) {
          this.aliyunOssToken = res.data || {};
          return this.aliyunOssToken;
        }
        const msg = (res && res.message) || "获取上传授权失败";
        this.$tbMessage({ type: "error", text: msg });
        throw new Error(msg);
      });
    },

    // 反馈弹窗截图上传，使用 OSS 直传
    handleFeedbackOssUpload(param) {
      const file = param.file;
      // 标记为上传中（由 FeedbackMixin 提供 feedbackUploading）
      if (typeof this.$set === "function") {
        this.feedbackUploading = true;
      } else {
        this.feedbackUploading = true;
      }
      if (!file || !this.aliyunOssToken || !this.aliyunOssToken.host) {
        console.warn(
          "OSS 授权信息不完整，尝试重新获取后重试上传",
          this.aliyunOssToken
        );
        // 若 token 缺失，先刷新后重试一次
        return this.getOssToken()
          .then(() => this.handleFeedbackOssUpload(param))
          .catch((err) => {
            if (typeof param.onError === "function") {
              param.onError(err);
            }
            this.feedbackUploading = false;
          });
      }

      let filename = "/" + this.getUUID() + "." + file.name.split(".").pop();
      const formData = new FormData();
      const dir = this.aliyunOssToken.dir || "";
      const fileUrl = `${dir}${filename}`;

      formData.append("key", fileUrl);
      formData.append("OSSAccessKeyId", this.aliyunOssToken.accessId);
      formData.append("policy", this.aliyunOssToken.policy);
      formData.append("Signature", this.aliyunOssToken.signature);
      formData.append("file", file);
      formData.append("expire", this.aliyunOssToken.expire);
      formData.append("success_action_status", 200);

      axios({
        url: this.aliyunOssToken.host,
        method: "post",
        data: formData,
        timeout: 3600000,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res && res.status === 200) {
            const pureFilename = filename.split("/")[1];
            const fullUrl = `${this.aliyunOssToken.host}/${fileUrl}`;

            if (param.file) {
              param.file.url = fullUrl;
            }

            if (this.feedbackForm) {
              this.feedbackForm.screenshotName = pureFilename;
            }

            if (typeof param.onSuccess === "function") {
              param.onSuccess(res, file);
            }
          } else {
            console.error("反馈截图上传失败", res);
            if (typeof param.onError === "function") {
              param.onError(new Error("upload failed"));
            }
          }
          this.feedbackUploading = false;
        })
        .catch((err) => {
          const status = err && err.response && err.response.status;
          const isAuthExpired = status === 403;
          console.error("反馈截图上传异常", err);

          // token 过期：刷新一次后重试（仅重试一次）
          if (isAuthExpired && !param.__ossRetry) {
            param.__ossRetry = true;
            return this.getOssToken()
              .then(() => this.handleFeedbackOssUpload(param))
              .catch((e) => {
                if (typeof param.onError === "function") {
                  param.onError(e);
                }
                this.feedbackUploading = false;
              });
          }

          if (typeof param.onError === "function") {
            param.onError(err);
          }
          this.feedbackUploading = false;
        });
    },
  },
};
